import { useEffect } from 'react';
import { motion, useMotionValue, useReducedMotion, useSpring } from 'framer-motion';
import { observeDocumentScroll } from '../hooks/useCardScroll';

export const ScrollProgress = () => {
  const value = useMotionValue(0);
  const scaleX = useSpring(value, { stiffness: 150, damping: 30 });
  const reduced = useReducedMotion();
  useEffect(() => {
    if (reduced) return;
    return observeDocumentScroll(({ scroll, height }) => {
      const length = document.documentElement.scrollHeight - height;
      value.set(length > 0 ? Math.max(0, Math.min(1, scroll / length)) : 0);
    });
  }, [reduced, value]);
  return reduced ? null : <motion.div className="page-scroll-progress" style={{ scaleX }} aria-hidden="true" data-testid="page-scroll-progress" />;
};